module.exports = __webpack_public_path__ + "img/pyramid.f299d71b.svg";